// src/components/Experience.js
import React from "react";
import { ChevronRight } from "lucide-react";
import SectionTitle from "./shared/SectionTitle";
import resumeData from "../data/resumeData";

const Experience = () => {
	const { experience, clubExperience } = resumeData;

	return (
		<section className="max-w-6xl mx-auto">
			<SectionTitle>Club Experience</SectionTitle>

			<div className="relative border-l-2 border-slate-200 pl-8 ml-4 space-y-10 mb-16">
				{clubExperience.map((club, index) => (
					<div
						key={index}
						className="relative bg-white border border-slate-200/80 shadow-card rounded-2xl p-8 transition-all duration-300 hover:shadow-lift hover:-translate-y-1"
					>
						<span className="absolute -left-[42px] top-9 h-3.5 w-3.5 rounded-full bg-brand-600 ring-4 ring-slate-50"></span>
						<div className="flex flex-col md:flex-row md:items-center justify-between mb-6 gap-3">
							<div>
								<h3 className="text-xl md:text-2xl font-bold text-slate-900">
									{club.position}
								</h3>
								<p className="text-brand-600 font-medium">
									{club.organization} | {club.location}
								</p>
							</div>
							<div className="self-start whitespace-nowrap px-3.5 py-1.5 bg-brand-50 text-brand-700 ring-1 ring-brand-100 rounded-full text-sm font-medium">
								{club.period}
							</div>
						</div>
						<ul className="space-y-2.5">
							{club.achievements.map((achievement, i) => (
								<li key={i} className="flex items-start text-slate-600">
									<ChevronRight
										className="text-brand-500 mt-1 mr-2 flex-shrink-0"
										size={16}
									/>
									<span>{achievement}</span>
								</li>
							))}
						</ul>
					</div>
				))}
			</div>

			<SectionTitle>Work Experience</SectionTitle>

			<div className="relative border-l-2 border-slate-200 pl-8 ml-4 space-y-10">
				{experience.map((job, index) => (
					<div
						key={index}
						className="relative bg-white border border-slate-200/80 shadow-card rounded-2xl p-8 transition-all duration-300 hover:shadow-lift hover:-translate-y-1"
					>
						<span className="absolute -left-[46px] top-8 flex h-7 w-7 items-center justify-center rounded-full bg-brand-600 text-xs font-semibold text-white ring-4 ring-slate-50">
							{index + 1}
						</span>
						<div className="flex flex-col md:flex-row md:items-center justify-between mb-6 gap-3">
							<div>
								<h3 className="text-xl md:text-2xl font-bold text-slate-900">
									{job.position}
								</h3>
								<p className="text-brand-600 font-medium">
									{job.company} | {job.location}
								</p>
							</div>
							<div className="self-start whitespace-nowrap px-3.5 py-1.5 bg-brand-50 text-brand-700 ring-1 ring-brand-100 rounded-full text-sm font-medium">
								{job.period}
							</div>
						</div>
						<ul className="space-y-2.5">
							{job.achievements.map((achievement, i) => (
								<li key={i} className="flex items-start text-slate-600">
									<ChevronRight
										className="text-brand-500 mt-1 mr-2 flex-shrink-0"
										size={16}
									/>
									<span>{achievement}</span>
								</li>
							))}
						</ul>
					</div>
				))}
			</div>
		</section>
	);
};

export default Experience;
